























import {Component, Prop, Vue} from 'vue-property-decorator';
import ZCLogo from '../assets/logo.svg';
// @ is an alias to /src

@Component({
	components: {
		ZCLogo
	}
})
export default class CompletedOverlay extends Vue {
	@Prop({
		default: 'blue'
	})
	color!: 'blue' | 'green';
	@Prop({
		default: ''
	})
	message!: string;
}
